import Modal from '../../../components/Modal';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface NormalizePromptModalProps {
  open: boolean;
  enableScriptNormalization?: boolean;
  t: Translate;
  onClose: () => void;
  onNormalize: () => void;
  onResolvePronouns: () => void;
}

export default function NormalizePromptModal({
  open,
  enableScriptNormalization,
  t,
  onClose,
  onNormalize,
  onResolvePronouns,
}: NormalizePromptModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={enableScriptNormalization ? t('normalizePrompt.titleNormalize') : t('normalizePrompt.titleResolve')}
      width="420px"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>{t('normalizePrompt.later')}</button>
          <button className="btn btn-primary" onClick={() => {
            onClose();
            if (enableScriptNormalization) {
              onNormalize();
            } else {
              onResolvePronouns();
            }
          }}>
            {enableScriptNormalization ? t('normalizePrompt.startNormalize') : t('normalizePrompt.startResolve')}
          </button>
        </>
      }
    >
      <p style={{ margin: 0, color: 'var(--text-2)', fontSize: '0.9rem', lineHeight: 1.6 }}>
        {enableScriptNormalization
          ? t('normalizePrompt.bodyNormalize')
          : t('normalizePrompt.bodyResolve')
        }
      </p>
    </Modal>
  );
}
